// extracted by mini-css-extract-plugin
export default {"container":"section_container__2ZDff","title":"section_title__pmg81"};